import {IconHeart} from "./svg-icons/IconHeart.tsx";
import '../styles/components/WishlistLink.css';

interface WishlistLinkProps {
    postId: string,
    activeClass?: string
    showTitle?: boolean
    alternativeTitle?: string
}

export function WishlistLink({
                                 postId,
                                 activeClass = '',
                                 showTitle = false,
                                 alternativeTitle
                             }: WishlistLinkProps) {


    return (
        <>
            {postId && (
                <a href="#" className={`wishlist ${activeClass}`} data-pid={postId}>
                    <span className="icon">
                        <IconHeart/>
                    </span>
                    {showTitle && (<span className="text">Merkliste</span>)}
                    {showTitle && alternativeTitle && (<span className="text">{alternativeTitle}</span>)}
                </a>
            )}
        </>
    )
}
